import type { SVGProps } from 'react';

const TrendDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4568 15.4159L17.7516 15.4154L17.8351 15.4038L17.9175 15.3808L17.9677 15.3595C18.0338 15.3305 18.0956 15.2883 18.15 15.2339L18.1839 15.1972L18.2202 15.1502L18.2653 15.0751L18.2976 14.9999L18.3135 14.9465L18.3249 14.8931L18.3326 14.8146L18.3331 8.53763C18.3331 8.19246 18.0532 7.91263 17.7081 7.91263C17.3916 7.91263 17.1301 8.14776 17.0888 8.45282L17.0831 8.53763L17.0827 13.2834L10.6503 6.84983C10.4284 6.62793 10.0812 6.60775 9.83653 6.78929L9.76642 6.8498L7.29102 9.32511L2.73296 4.76704C2.48888 4.52296 2.09315 4.52296 1.84907 4.76704C1.62719 4.98893 1.60701 5.33615 1.78856 5.58083L1.84907 5.65093L6.84907 10.6509C7.07096 10.8728 7.41817 10.893 7.66285 10.7114L7.73295 10.6509L10.2083 8.17564L16.1977 14.1659H11.4568C11.1404 14.1659 10.8789 14.401 10.8375 14.7061L10.8318 14.7909C10.8318 15.1073 11.0669 15.3688 11.372 15.4102L11.4568 15.4159Z"
      fill="currentColor"
    />
  </svg>
);

export default TrendDownIcon;
